import { Skeleton } from 'antd';
import React from 'react';

import SystemTips from '@/components/SystemTips';

const Loading: React.FC = () => (
  <div
    style={{
      minHeight: '60vh',
      padding: '24px 40px',
      display: 'flex',
      flexDirection: 'column',
      gap: 18,
    }}
  >
    <Skeleton style={{ height: '45vh' }} active />
    <SystemTips placement="loading" style={{ alignSelf: 'center' }} />
  </div>
);

export default Loading;
